
import axios from 'axios'
import { getToken } from '@/api/token'

async function callAssociates (action, path, payload = {}) {
  var token = await getToken('clients')

  // Construct full URL using VUE_APP_API_ROOT + 'clients' + path
  var url = process.env.VUE_APP_API_ROOT + 'clients' + path

  switch (action) {
    case 'post':
      try {
        const response = await axios.post(url, payload, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })

        if (response) {
          return response
        }
      } catch (error) {
        return error.response
      }
      break
    case 'get':
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + token
          },
          params: payload.params || {}
        })

        if (response) {
          return response
        }
      } catch (error) {
        return error.response
      }

      break
    case 'patch':

      try {
        const response = await axios.patch(url, payload, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })

        if (response) {
          return response
        }
      } catch (error) {
        return error.response
      }

      break
    case 'delete':

      try {
        const response = await axios.delete(url, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })

        if (response) {
          return response
        }
      } catch (error) {
        return error.response
      }
  }
}

async function callBusinessEntities (oib) {
  var token = await getToken('clients')
  var url = process.env.VUE_APP_API_ROOT + 'businessentites'

  const payload = {
    data: {
      filter: 'oib',
      oib: oib
    }
  }

  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })

    if (response) {
      return response
    }
  } catch (error) {
    return error.response
  }
}

export { callAssociates, callBusinessEntities }
